module.exports = __webpack_public_path__ + "img/img-null.8295b38a.png";